import React from 'react';
import ReactDOM from 'react-dom/client';
import PluginApp from './app/PluginApp';
import IntakePluginApp from './app/IntakePluginApp';
import { FrontendConfigurationProvider } from './components/FrontendConfigurationProvider';
import { axiosInstance } from './components/api';
import axios from 'axios';

function initializeChatPlugin({ token, pluginType, AppComponent, fullscreen }) {
  if (!token) {
    throw new Error(
      `${pluginType} token is required to initialize the ${pluginType} chat plugin`
    );
  }

  // Determine the correct backend to connect to.
  let backendOrigin = '';
  const script = document.getElementById(`plugin-${token}`);
  if (script) {
    const scriptURL = new URL(script.src);
    backendOrigin = scriptURL.origin;
  } else {
    backendOrigin = window.location.origin; // If the plugin script object can't be found, then assume the window origin.
  }
  backendOrigin = backendOrigin.replace('/app/', '').replace(/\/$/, '');
  const backendOriginParsed = new URL(backendOrigin);
  const backendHostName = backendOriginParsed.hostname;

  // Load the CSS file from the public folder
  const link = document.createElement('link');
  link.rel = 'stylesheet';

  link.href = `${backendOrigin}/plugin/static/css/plugin.css`;
  document.head.appendChild(link);
  axiosInstance.defaults.baseURL = `${backendOrigin}/api/`;
  axiosInstance.defaults.headers['X-Client-Tenant-Host'] = backendHostName;

  // Create the plugin root element
  const chatBotPlugin = document.createElement('div');
  chatBotPlugin.id = 'web-chat-plugin-root';
  chatBotPlugin.className = 'web-chat-plugin-root';
  document.body.appendChild(chatBotPlugin);

  const root = ReactDOM.createRoot(chatBotPlugin);
  root.render(
    <React.StrictMode>
      <FrontendConfigurationProvider showBootScreen={false}>
        <AppComponent token={token} fullscreen={fullscreen} />
      </FrontendConfigurationProvider>
    </React.StrictMode>
  );
}

window.WebChat = {
  init(options) {
    const { clientToken: token, fullscreen } = options;
    initializeChatPlugin({
      token,
      pluginType: 'Client',
      AppComponent: PluginApp,
      fullscreen,
    });
  },
};

window.IntakeChat = {
  init(options) {
    const { intakeToken: token, fullscreen } = options;
    initializeChatPlugin({
      token,
      pluginType: 'Intake',
      AppComponent: IntakePluginApp,
      fullscreen,
    });
  },
};

if (window.location.pathname.startsWith('/plugin/full-screen/')) {
  // Determine if the path is for WebChat or IntakeChat
  const pathSegments = window.location.pathname.split('/plugin/full-screen/');

  if (pathSegments[1].startsWith('intake/')) {
    const intakeToken = pathSegments[1].split('intake/')[1];
    window.IntakeChat.init({ intakeToken, fullscreen: true });
  } else {
    const clientToken = pathSegments[1];
    window.WebChat.init({ clientToken, fullscreen: true });
  }
}
